"use strict";

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEGoogleMap = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactGoogleMaps = require("react-google-maps");

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

var _FAEContainer = require("../FAEContainer/FAEContainer");

require("./FAEGoogleMap.scss");

const _excluded = ["justify", "align", "className", "apiKey", "getMapValues", "lat", "lng", "address", "height"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const GMap = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(props => /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.GoogleMap, {
  google: props.google,
  defaultZoom: 16,
  defaultCenter: {
    lat: props.lat,
    lng: props.lng
  }
}, props.children)));

const FAEGoogleMap = _ref => {
  let {
    justify,
    align,
    className,
    apiKey,
    getMapValues = () => {},
    lat,
    lng,
    address = "",
    height = "300px"
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  _reactGeocode.default.setApiKey(apiKey);

  _reactGeocode.default.enableDebug();

  (0, _react.useEffect)(() => {
    if (address === "") {
      navigator.geolocation.getCurrentPosition(position => {
        _reactGeocode.default.fromLatLng(position.coords.latitude, position.coords.longitude).then(response => {
          const address = response.results[0].formatted_address;
          const addressComponents = response.results[0].address_components;
          address && getMapValues({
            mapAddress: address,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            addressComponents
          });
        }, error => {
          console.error(error);
        });
      });
    }
  }, [address, getMapValues]);

  const getDragEndResults = event => {
    _reactGeocode.default.fromLatLng(event.latLng.lat(), event.latLng.lng()).then(response => {
      const address = response.results[0].formatted_address;
      const addressComponents = response.results[0].address_components;
      address && getMapValues({
        mapAddress: address,
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
        addressComponents
      });
    }, error => {
      console.error(error);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, /*#__PURE__*/_react.default.createElement(GMap, _extends({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&libraries=places"),
    loadingElement: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "100%"
      }
    }),
    containerElement: /*#__PURE__*/_react.default.createElement("div", {
      className: "fae--google-map ".concat(className),
      style: {
        height: height
      }
    }),
    mapElement: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "100%"
      }
    }),
    lat: lat,
    lng: lng
  }, rest), /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Marker, {
    draggable: true,
    position: {
      lat,
      lng
    },
    onDragEnd: e => getDragEndResults(e)
  }), /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.InfoWindow, {
    onClose: e => {},
    position: {
      lat: lat + 0.00089,
      lng: lng
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      padding: 0,
      margin: 0
    }
  }, address))))));
};

exports.FAEGoogleMap = FAEGoogleMap;